export const PATH_SECTORS = "/sectors";
export const PATH_SECTORS_CODE = `${PATH_SECTORS}/:code`;
export const PATH_SECTORS_CODE_DTWINS = `${PATH_SECTORS_CODE}/dtwins`;
export const PATH_SECTORS_CODE_GROUPS = `${PATH_SECTORS_CODE}/groups`;
export const PATH_SECTORS_CODE_USERS = `${PATH_SECTORS_CODE}/users`;
export const PATH_SECTORS_CODE_SECTORS = `${PATH_SECTORS_CODE}/sectors`;

export const SECTOR_NAME_MIN_LENGTH = 1;
export const SECTOR_NAME_MAX_LENGTH = 30;
export const SECTOR_DESCRIPTION_MAX_LENGTH = 500;
export const MAX_SECTOR_DEPTH = 10;
